import { render, staticRenderFns } from "./noResouse.vue?vue&type=template&id=578754da&scoped=true&"
import script from "./noResouse.vue?vue&type=script&lang=js&"
export * from "./noResouse.vue?vue&type=script&lang=js&"
import style0 from "./noResouse.vue?vue&type=style&index=0&id=578754da&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578754da",
  null
  
)

export default component.exports